import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-consent-footer',
  imports: [],
  templateUrl: './consent-footer.component.html',
  styleUrl: './consent-footer.component.scss',
  standalone: false
})
export class ConsentFooterComponent implements OnInit {
  maxisCopyright: string = "Copyright © 2026 Maxis Bhd. All rights reserved.";
  priceStated : string = "Price stated may be subject to Service Tax";
  redressYourComplaints: string = "Redress your complaints at the Consumer Forum Malaysia (CFM)   |   www.complaint.cfm.org.my";

  ngOnInit(): void {
  }

}
